export default "__VITE_ASSET__XsiL$WZp__"